var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Development'),_c('section',{attrs:{"id":"container"}},[_c('router-view'),_c('div',{staticClass:"bg"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }